import { Injectable } from '@angular/core';
import {
    boolean_DoctorProfileUpdateDataSubmit,
    DoctorProfileUpdateDataSubmit
} from '../models/Doctorprofile';
import {
    boolean_dregistration,
    Column,
    CountrySelectedValue,
    DoctorRegTable,
    DoctorRegTemp,
    DoctorRegTemp_id,
    DoctorSaveData,
    doctor_register_api_data,
    dregistration,
    labels_doctorreg,
    StateSelectedValue,
    TableData
} from '../models/doctorregistration';
import {
    boolean_medprofregistration,
    boolean_medprofUpdateDataSubmit,
    medprofregistration,
    medprofUpdateDataSubmit,
    OMH_Registration_Data
} from '../models/medicalproffessional';
import { ApiResult, PromiseResult } from '../models/PromiseResult';
import {
    Form_Data,
    OtpData,
    PasswordInput,
    RecaptchaData,
    TabView_Data
} from '../models/util.models';
import { CommonService } from './common.service';
import { DaterenderService } from './daterender.service';

@Injectable({
    providedIn: 'root'
})
export class DoctorRegistrationCheckerService {
    constructor(
        private readonly daterenderService: DaterenderService,
        private readonly commonService: CommonService
    ) { }

    // RestoreDataNullChecker(doctorData: doctor_register_api_data): boolean {
    //     for (let i = 0; i < Object.keys(doctorData).length; i++) {
    //         if (typeof doctorData[Object.keys(doctorData)[i]] === 'string') {
    //             if (doctorData[Object.keys(doctorData)[i]].length > 0) {
    //                 return true;
    //             }
    //         } else if (
    //             typeof doctorData[Object.keys(doctorData)[i]] === 'object'
    //         ) {
    //             if (doctorData[Object.keys(doctorData)[i]] instanceof Array) {
    //                 if (doctorData[Object.keys(doctorData)[i]].length > 0) {
    //                     return true;
    //                 }
    //             } else {
    //                 if (doctorData[Object.keys(doctorData)[i]] != null) {
    //                     return true;
    //                 }
    //             }
    //         }
    //     }
    // }

    async isNotNullObject(obj: any) {
        for (const key of Object.keys(obj)) {
            if (Boolean(obj[key])) {
                if (typeof obj[key] === 'object') {
                    return this.isNotNullObject(obj[key]);
                } else {
                    return Boolean(obj[key]);
                }
            }
        }
        return false;
    }

    RestoreDataNullChecker(doctorData: doctor_register_api_data): boolean {
        // for (let i = 0; i < Object.keys(doctorData).length; i++) {
        //     if (typeof doctorData[Object.keys(doctorData)[i]] === 'string') {
        //         if (doctorData[Object.keys(doctorData)[i]].length > 0) {
        //             return true;
        //         }
        //     } else if (
        //         typeof doctorData[Object.keys(doctorData)[i]] === 'object'
        //     ) {
        //         if (doctorData[Object.keys(doctorData)[i]] instanceof Array) {
        //             if (doctorData[Object.keys(doctorData)[i]].length > 0) {
        //                 return true;
        //             }
        //         } else {
        //             if (doctorData[Object.keys(doctorData)[i]] != null) {
        //                 return true;
        //             }
        //         }
        //     }
        // }

        return Boolean(this.isNotNullObject(doctorData));
    }

    saveDataLocalStorage(name: string, doctorData: dregistration) {
        if (Boolean(doctorData.api_data.date_of_birth_date))
            doctorData.api_data.date_of_birth =
                this.daterenderService.render_data(
                    doctorData.api_data.date_of_birth_date
                );

        doctorData.api_data.timezone = 0;
        doctorData.api_data.featured_doctor_id = false;
        doctorData.api_data.role_id = 1;

        doctorData.api_data.country_id =
            doctorData.others.selected_country_data?.id || null;

        if (Boolean(doctorData.api_data.country_id)) {
            doctorData.api_data.primary_contact_number =
                doctorData.others.phone_code + doctorData.others.primary_number;
            doctorData.others.selected_state_data =
                (JSON.parse(
                    doctorData.others.selected_state
                ) as StateSelectedValue) || this.getStateSelectedValue_init();
            doctorData.api_data.state_name =
                doctorData.others.selected_state_data.state_name || null;
        }

        doctorData.others.MedicalSchool =
            doctorData.others.MedicalSchool.filter(
                (element) => element.name.length > 0 && element.year.length > 0
            );
        doctorData.others.StatesToPractice =
            doctorData.others.StatesToPractice.filter(
                (element) =>
                    element.license_no.length > 0 &&
                    element.state_data.length > 0
            );

        doctorData.api_data.education = {
            medical_school: doctorData.others.MedicalSchool,
            residency: doctorData.others.Residency,
            fellowship: doctorData.others.Fellowship
        };

        if (!doctorData.others.is_national_license) {
            doctorData.api_data.states_to_practice =
                doctorData.others.StatesToPractice;
        } else if (doctorData.others.is_national_license) {
            doctorData.api_data.states_to_practice = [];
            if (doctorData.others.national_license_number.length > 0) {
                doctorData.api_data.states_to_practice.push({
                    si_no: '1',
                    state_name: 'ALL',
                    state_id: 0,
                    license_no: doctorData.others.national_license_number,
                    state_data: JSON.stringify({
                        state_name: 'ALL',
                        state_id: 0
                    })
                });
            }
        }

        let save_data: doctor_register_api_data = JSON.parse(
            JSON.stringify(doctorData.api_data)
        ) as doctor_register_api_data;

        save_data.d_password = '';
        save_data.confirm_d_password = '';
        save_data.pin = '';
        save_data.recaptcha = '';

        localStorage.setItem(name, JSON.stringify(save_data));
    }

    fetchDataLocalStorage(
        name: string,
        doctorData: dregistration
    ): dregistration {
        let result_data: dregistration = doctorData;
        let fetchedData: doctor_register_api_data = JSON.parse(
            localStorage.getItem(name)
        ) as doctor_register_api_data;
        result_data.api_data = fetchedData;
        if (Boolean(result_data.api_data.country_id)) {
            result_data.others.selected_country =
                result_data.others_data.countries.filter(
                    (ele) =>
                        (JSON.parse(ele.value) as CountrySelectedValue).id ==
                        result_data.api_data.country_id
                )[0].value;
            result_data.others.selected_country_data = JSON.parse(
                result_data.others.selected_country
            ) as CountrySelectedValue;
            result_data.others.phone_code =
                result_data.others.selected_country_data.phone_code;
            result_data.others.is_national_license =
                result_data.others.selected_country_data.is_national_license;
        }
        if (Boolean(result_data.api_data.date_of_birth))
            result_data.api_data.date_of_birth_date = new Date(
                result_data.api_data.date_of_birth.replace(/-/g, '/')
            );

        if (Boolean(result_data.api_data.primary_contact_number) && (result_data.api_data.primary_contact_number?.length > 8))
            result_data.others.primary_number =
                result_data.api_data.primary_contact_number?.slice(-10);

        if (Boolean(this.isNotNullObject(result_data.api_data.education))) {
            result_data.others.MedicalSchool =
                result_data.api_data.education.medical_school || [];
            result_data.others.Fellowship =
                result_data.api_data.education.fellowship || [];
            result_data.others.Residency =
                result_data.api_data.education.residency || [];
        }

        result_data.others.StatesToPractice =
            result_data.api_data.states_to_practice;

        if (result_data.others.is_national_license) {
            // if (result_data.others.national_license_number.length > 0) {
            //     result_data.api_data.states_to_practice.push({
            //         si_no: (1).toString(),
            //         state_name: "ALL",
            //         state_id: 0,
            //         license_no: result_data.others.national_license_number,
            //         state_data: JSON.stringify({
            //             state_name: "ALL",
            //             state_id: 0
            //         }),
            //     })
            // }
            if (
                result_data.others.StatesToPractice.length > 0 &&
                result_data.others.StatesToPractice[0]['state_name'] == 'ALL' &&
                result_data.others.StatesToPractice[0]['state_id'] == 0
            ) {
                result_data.others.national_license_number =
                    result_data.others.StatesToPractice[0]['license_no'];
            }
        }

        return result_data;
    }

    boolean_doctorRegistration_init() {
        let doctorReg_checker: boolean_dregistration = {
            first_name: true,
            last_name: true,
            gender: true,
            d_email: true,
            d_password: true,
            confirm_d_password: true,
            d_password_equal: true,
            date_of_birth: true,
            language_id: true,
            role_id: true,
            featured_doctor_id: true,
            country_id: true,
            city: true,
            address_line_1: true,
            primary_contact_number: true,
            state_name: true,
            zip_code: true,
            primary_speciality_id: true,
            salutation: true,
            years_experience: true,
            npi_number: true,
            degree: true,
            states_to_practice: true,
            medical_school: true,
            // residency: true,
            // board_certification: true,
            profile_photo: true,
            pin: true,
            signature: true,
            description: true,
            recaptcha: true,
            agree: true,
            pin_number_string: true,
            primary_contact_number_number_string: true,
            user_source_id: true,
            other_source: true
        };
        return doctorReg_checker;
    }

    doctorRegTemp_id_init(): DoctorRegTemp_id {
        let doctorRegTemp_data: DoctorRegTemp_id = {
            MedicalSchool: -1,
            Fellowship: -1,
            StatesToPractice: -1,
            Honours: -1,
            Privileges: -1,
            Residency: -1,
            Board: -1,
            Publication: -1
        };
        return doctorRegTemp_data;
    }

    doctorRegTemp_init(): DoctorRegTemp {
        let doctorRegTemp_data: DoctorRegTemp = {
            MedicalSchool: {
                si_no: '',
                name: '',
                year: null
            },
            Fellowship: {
                si_no: '',
                name: '',
                year: null
            },
            StatesToPractice: {
                si_no: '',
                state_name: '',
                state_id: -1,
                license_no: '',
                state_data: ''
            },
            Honours: {
                si_no: '',
                name: ''
            },
            Privileges: {
                si_no: '',
                name: ''
            },
            Residency: {
                si_no: '',
                name: '',
                year: null
            },
            Board: {
                si_no: '',
                name: ''
            },
            Publication: {
                si_no: '',
                name: ''
            }
        };
        return doctorRegTemp_data;
    }

    getColStrings(element: string, type: string) {
        if (element == 'si_no') {
            if (type == 'string') element = 's_si_no';
            else if (type == 'number') element = 'n_si_no';
        }

        return element;
    }

    addEditString(type_data) {
        let strings_list = [];
        strings_list = Object.keys(type_data);
        strings_list.push('edit');
        return strings_list;
    }

    replaceElement(data: string[], old_value: string, new_value: string) {
        data[data.indexOf(old_value)] = new_value;
        return data;
    }

    doctorRegistrationTableData_init(): DoctorRegTable {
        let temp_type: DoctorRegTemp = this.doctorRegTemp_init();

        let doctorReg_data: DoctorRegTable = {
            MedicalSchool: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['MedicalSchool']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Fellowship: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Fellowship']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            StatesToPractice: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['StatesToPractice']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Honours: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Honours']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Privileges: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Privileges']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Residency: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Residency']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Board: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Board']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            },
            Publication: {
                columns: this.getColumnsData(
                    this.replaceElement(
                        this.addEditString(temp_type['Publication']),
                        'si_no',
                        's_si_no'
                    ).map((ele) => this.getColStrings(ele, 'string'))
                ),
                refresh: true
            }
        };

        return doctorReg_data;
    }

    getColumn(string: string): Column {
        let column: Column;
        if (string == 'si_no') {
            column = {
                field: 'si_no',
                header: '#',
                is_edit: false,
                is_key: true,
                is_display: true,
                input_type: 'text',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 's_si_no') {
            column = {
                field: 'si_no',
                header: '#',
                is_edit: false,
                is_key: true,
                is_display: true,
                input_type: 'text',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'n_si_no') {
            column = {
                field: 'si_no',
                header: '#',
                is_edit: false,
                is_key: true,
                is_display: true,
                input_type: 'text',
                data_type: 'number',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'name') {
            column = {
                field: 'name',
                header: 'Name',
                is_edit: true,
                is_key: false,
                is_display: true,
                input_type: 'textarea',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'year') {
            column = {
                field: 'year',
                header: 'Year',
                is_edit: true,
                is_key: false,
                is_display: true,
                input_type: 'dropdown',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'state_name') {
            column = {
                field: 'state_name',
                header: 'State Name',
                is_edit: false,
                is_key: false,
                is_display: false,
                input_type: 'dropdown',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'state_id') {
            column = {
                field: 'state_id',
                header: '',
                is_edit: false,
                is_key: false,
                is_display: false,
                input_type: 'text',
                data_type: 'number',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'state_data') {
            column = {
                field: 'state_data',
                header: 'State Name',
                is_edit: true,
                is_key: false,
                is_display: true,
                input_type: 'dropdown',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'license_no') {
            column = {
                field: 'license_no',
                header: 'License No',
                is_edit: true,
                is_key: false,
                is_display: true,
                input_type: 'text',
                data_type: 'string',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: true
            };
        } else if (string == 'edit') {
            column = {
                field: 'edit',
                header: 'Edit',
                is_edit: false,
                is_key: false,
                is_display: true,
                input_type: 'button',
                data_type: 'none',
                data: [],
                th_class_name: '',
                tr_class_name: '',
                input_class_name: '',
                is_data_field: false
            };
        }
        return column;
    }

    getColumnsData(cols_string: string[]): Column[] {
        let columns_data: Column[] = [];
        columns_data = cols_string.map((ele) => this.getColumn(ele));
        return columns_data;
    }

    getCountrySelectedValue_init(): CountrySelectedValue {
        let countrySelectedValueData: CountrySelectedValue = {
            id: null,
            is_national_license: null,
            phone_code: null
        };
        return countrySelectedValueData;
    }

    getStateSelectedValue_init(): StateSelectedValue {
        let stateSelectedValueData: StateSelectedValue = {
            id: null,
            state_name: null
        };
        return stateSelectedValueData;
    }

    DoctorRegistrationApiData(is_doctor: boolean) {
        let api_data: doctor_register_api_data = {
            salutation: null,
            is_doctor: is_doctor,
            d_email: '',
            d_password: '',
            confirm_d_password: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            gender: '',
            date_of_birth: null,
            date_of_birth_date: null,
            country_id: null,
            state_name: null,
            city: '',
            address_line_1: '',
            address_line_2: '',
            zip_code: '',
            role_id: null,
            primary_speciality_id: null,
            secondary_speciality: [],
            featured_doctor_id: null,
            years_experience: null,
            license_number: '',
            degree: '',
            education: null,
            timezone: null,
            npi_number: '',
            revalidation_cme: null,
            states_to_practice: [],
            board_certification: [],
            honors_awards_recognition: [],
            publications: [],
            hospital_privileges: [],
            description: '',
            primary_contact_number: '',
            secondary_contact_number: '',
            pin: '',
            language_id: [],
            recaptcha: '',
            avatar: null,
            resume: null,
            user_source_id: 12,
            other_user_source: 'SELF-REGISTRATION',
            gmc_reg_no: null,
            passing_year: null,
            certificates:null,
            certificates_data:[]
        };
        return api_data;
    }

    doctorRegistration_init(is_doctor: boolean) {
        let doctorReg_data: dregistration = {
            api_data: this.DoctorRegistrationApiData(is_doctor),
            form_data: new Form_Data(),
            others: {
                selected_country: null,
                selected_country_data: this.getCountrySelectedValue_init(),
                selected_state: null,
                selected_state_data: this.getStateSelectedValue_init(),
                primary_number: '',
                phone_code: '',
                is_national_license: true,
                secondary_number: '',
                // confirm_password: "",
                // password_masking: false,
                // pin_masking: false,
                // password_tips: false,
                passwordData: new PasswordInput(),
                pinData: new PasswordInput(),
                recaptchaData: new RecaptchaData(),
                national_license_number: '',
                MedicalSchool: [],
                Fellowship: [],
                StatesToPractice: [],
                Honours: [],
                Privileges: [],
                Residency: [],
                Board: [],
                Publication: [],
                agree: true,
                // resume: null,
                // profilePhoto: null,
                signatureOptionSelected: null,
                signatureFile: null,
                is_super_admin: false,
                fetchDataDialog: this.commonService.confirmDialog_init(),
                successDialog: this.commonService.confirmDialog_init(),
                show_form: false,
                formData_apiResult: new ApiResult(false),
                form_error_message_result: new ApiResult(false),
                tabViewData: new TabView_Data(0, 1),
                otp_data: new OtpData(0),
                // formData_response: this.utilitiesService.getResultResponse(),
                // profilePhoto_response: this.utilitiesService.getResultResponse(),
                // resume_response: this.utilitiesService.getResultResponse(),
                email: '',
                user_source: []
            },
            others_data: {
                countries: [],
                states: [],
                languages: [],
                salutations: [],
                primary_specialties: [],
                secondary_specialties: [],
                years: [],
                year: new Date().getFullYear(),
                form_data: new Form_Data()
            },
            // temp: this.doctorRegTemp_init(),
            // temp_id: this.doctorRegTemp_id_init(),
            // current_temp: this.doctorRegTemp_init(),
            table_data: this.doctorRegistrationTableData_init()
        };
        return doctorReg_data;
    }

    otherMedicaldProfRegistration_init() {
        let otherReg_data: OMH_Registration_Data = {
            api_data: {
                has_saved: null,
                guid: {
                    user_guid: null,
                    current_user_guid: null
                },
                token: null,
                d_email: '',
                d_password: '',
                confirm_d_password: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                gender: '',
                date_of_birth: null,
                date_of_birth_date: null,
                country_id: null,
                state_name: null,
                city: '',
                address_line_1: '',
                address_line_2: '',
                zip_code: '',
                certifications: [],
                education: [],
                affiliated_hospitals: [],
                license_number: '',
                primary_occupation: null,
                secondary_occupation: null,
                description: '',
                primary_contact_number: '',
                secondary_contact_number: '',
                years_of_experience: null,
                recaptcha: '',
                language_id: [],
                avatar: null,
                resume: null,
                user_source_id: null,
                other_source: ''
            },
            other_data: {
                reg_api_result: new ApiResult(),
                // formData_apiResult: new ApiResult(),
                form_error_message_result: new ApiResult(),
                otp_data: new OtpData(0),
                passwordData: new PasswordInput(),
                recaptchaData: new RecaptchaData(),
                tabViewData: new TabView_Data(0, 1),
                form_data: new Form_Data(),
                email: '',
                user_source: []
            }
        };
        return otherReg_data;
    }

    DoctorSaveData_init(name: string): DoctorSaveData {
        let data: DoctorSaveData = {
            local_storage_object_name: name,
            masterChecker: false
        };
        return data;
    }

    getFileResponse(data: File, result: PromiseResult) {
        return data == null ? true : result.success;
    }

    //this is use for all the forms
    labels_doctorRegistration_init() {
        let doctorReg_labels: labels_doctorreg = {
            first_name: 'First Name',
            last_name: 'Last Name',
            gender: 'Gender',
            d_email: 'Email',
            date_of_birth: 'Date Of Birth',
            language_id: 'Language Spoken',
            role_id: 'Role',
            featured_doctor_id: 'Featured',
            d_password: 'Password',
            confirm_d_password: 'Confirm Password',
            country_id: 'Country',
            city: 'City',
            address_line_1: 'Address 1',
            primary_contact_number: 'Primary No.',
            state_name: 'State',
            zip_code: 'Zip/Pin Code',
            primary_speciality_id: 'Primary Speciality',
            primary_occupation: 'Primary Occupation',
            salutation: 'Salutation',
            license_number: 'License Number',
            years_experience: 'Experience in Years',
            years_of_experience: 'Experience in Years',
            npi_number: 'NPI/GMC/IMC Number',
            degree: 'Medical Degree',
            states_to_practice: null,
            medical_school: 'Medical School',
            school: 'School/College',
            residency: 'Residency/Specialist Training/PG',
            board_certification: 'Board Certifications',
            profile_photo: 'Profile Photo',
            resume_cv: 'Resume/CV',
            pin: 'Pin',
            signature: 'eSignature',
            description: 'Description',
            recaptcha: 'Recaptcha',
            agree: 'Agree',
            pin_number_string: 'Pin',
            primary_contact_number_number_string: 'Primary No.',
            user_source_id: 'User Source',
            other_source: 'Other Source'
        };
        return doctorReg_labels;
    }

    boolean_DoctorProfileUpdateDataSubmit_init() {
        let doctorProfUpdateSubmit_checker: boolean_DoctorProfileUpdateDataSubmit =
        {
            first_name: true,
            last_name: true,
            gender: true,
            date_of_birth: true,
            language_id: true,
            is_password: true, //nr-c //*
            d_password: true, //nr-c //*
            d_password_equal: true, //nr-c //*
            country_id: true,
            city: true,
            address_line_1: true,
            primary_contact_number: true,
            state_name: true,
            zip_code: true,
            primary_speciality_id: true,
            salutation: true,
            years_experience: true,
            npi_number: true,
            degree: true,
            states_to_practice: true,
            medical_school: true, //*
            residency: true, //*
            board_certification: true,
            is_profile_photo: true, //nr-c //*
            profile_photo: true, //nr-c //*
            is_resume_cv: true, //nr-c //*
            resume_cv: true, //nr-c //*
            is_pin: true, //nr-c //*
            pin: true, //nr-c //*
            is_signature: true, //nr-c //*
            signature: true, //nr-c //*
            description: true,
            recaptcha: true //*
        };

        return doctorProfUpdateSubmit_checker;
    }

    boolean_medprofregistration_init() {
        let medprofregistrationSubmit_checker: boolean_medprofregistration = {
            first_name: true,
            last_name: true,
            gender: true,
            d_email: true,
            d_password: true,
            confirm_d_password: true,
            d_password_equal: true,
            date_of_birth: true,
            language_id: true,
            country_id: true,
            city: true,
            address_line_1: true,
            primary_contact_number: true,
            state_name: true,
            zip_code: true,
            primary_occupation: true,
            years_of_experience: true,
            school: true, //*
            description: true,
            recaptcha: true, //*
            agree: true,
            profile_photo: true,
            user_source_id: true,
            other_source: true
        };

        return medprofregistrationSubmit_checker;
    }

    boolean_medprofUpdateDataSubmit_init() {
        let medprofUpdateDataSubmit_checker: boolean_medprofUpdateDataSubmit = {
            first_name: true,
            last_name: true,
            gender: true,
            date_of_birth: true,
            language_id: true,
            is_password: true, //nr-c //*
            d_password: true, //nr-c //*
            confirm_d_password: true, //nr-c //*
            d_password_equal: true, //nr-c //*
            country_id: true,
            city: true,
            address_line_1: true,
            primary_contact_number: true,
            state_name: true,
            zip_code: true,
            primary_occupation: true,
            years_of_experience: true,
            school: true, //*
            is_profile_photo: true, //nr-c //*
            profile_photo: true, //nr-c //*
            is_resume_cv: true, //nr-c //*
            resume_cv: true, //nr-c //*
            description: true,
            recaptcha: true //*
        };

        return medprofUpdateDataSubmit_checker;
    }

    stringChecker1(data: string): boolean {
        // Dont Delete
        //^^^initialized with empty string^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()].length == 0 || !Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()].length > 0 || Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return (data || '').length > 0;
    }

    stringChecker2(data: string): boolean {
        // Dont Delete
        // ^^^initialized with null^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()] == null || doctorData[Object.keys(doctorFormChecker)[i].toString()].length == 0 || !Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()] != null || doctorData[Object.keys(doctorFormChecker)[i].toString()].length > 0 || Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return Boolean(data);
    }

    numberChecker2(data: number): boolean {
        // Dont Delete
        // ^^^initialized with null^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()] == null || doctorData[Object.keys(doctorFormChecker)[i].toString()].length == 0 || !Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()] != null || doctorData[Object.keys(doctorFormChecker)[i].toString()].length > 0 || Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return data != null;
    }

    arrayChecker1(data: any[]): boolean {
        // Dont Delete
        //^^^initialized with empty string^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()].length == 0)
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()].length > 0)
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return data.length > 0;
    }

    fileChecker2(data: File): boolean {
        // Dont Delete
        // ^^^initialized with null^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()] == null  || !Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()] != null  || Boolean(doctorData[Object.keys(doctorFormChecker)[i].toString()]))
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return data != null;
    }

    booleanChecker2(data): boolean {
        // Dont Delete
        // ^^^initialized with null^^^
        // Below code is represntation of this
        // if (doctorData[Object.keys(doctorFormChecker)[i].toString()] == null)
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = false;
        // else if (doctorData[Object.keys(doctorFormChecker)[i].toString()] != null )
        // doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
        return data != null;
    }

    isNumericString(s: string): boolean {
        let re = new RegExp('^[0-9]*$');
        return re.test(s);
    }

    //used in register-doctor...and others
    async DoctorRegistrationFormSubmitChecker(
        doctorData: doctor_register_api_data,
        is_super_admin: boolean = false,
        photo_profile: File,
        signature_option: string,
        signature: any,
        agree: boolean
    ) {
        let doctorFormChecker: boolean_dregistration =
            this.boolean_doctorRegistration_init();

        let string_fields_1 = [
            'first_name',
            'last_name',
            'gender',
            'd_email',
            // 'city',
            // 'address_line_1',
            'primary_contact_number',
            // 'zip_code',
            // 'npi_number',
            'degree',
            'pin',
            'd_password',
            'confirm_d_password',
            //'other_source'
            // 'description'
        ];
        //^^^initialized with empty string^^^
        let string_fields_2 = [
            'date_of_birth',
            'state_name',
            'salutation',
            'recaptcha'
        ];
        // ^^^initialized with null^^^
        let number_fields_2 = [
            'country_id',
            'primary_speciality_id',
            'user_source_id'
            // 'years_experience'
        ];
        // ^^^initialized with null^^^
        let array_fields_1 = [
            'language_id',
            'states_to_practice'
            // 'board_certification'
        ];
        //^^^initialized with empty array^^^
        let education_fields = [
            'medical_school'
            // 'residency'
        ];
        let password_fields = ['d_password_equal'];

        let agree_fields = ['agree'];

        let number_string_fields_checker = [
            'pin_number_string',
            'primary_contact_number_number_string'
        ];

        //^^^initialized with empty object^^^

        for (const key of Object.keys(doctorFormChecker)) {
            if (string_fields_1.includes(key)) {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (string_fields_2.includes(key)) {
                doctorFormChecker[key] = this.stringChecker2(
                    doctorData[key.toString()]
                );
            } else if (number_fields_2.includes(key)) {
                doctorFormChecker[key] = this.numberChecker2(
                    doctorData[key.toString()]
                );
            } else if (array_fields_1.includes(key)) {
                doctorFormChecker[key] = this.arrayChecker1(
                    doctorData[key.toString()]
                );
            } else if (password_fields.includes(key)) {
                doctorFormChecker[key] =
                    doctorFormChecker['d_password'] ==
                    doctorFormChecker['confirm_d_password'];
            } else if (agree_fields.includes(key)) {
                doctorFormChecker[key] = doctorFormChecker['agree'] == agree;
            } else if (number_string_fields_checker.includes(key)) {
                let key_name: string = key
                    .toString()
                    .split('_number_string')[0];
                if (doctorData[key_name]?.toString().length > 4) {
                    doctorFormChecker[key] = this.isNumericString(
                        doctorData[key_name].slice(1)
                    );
                } else {
                    doctorFormChecker[key] = this.isNumericString(
                        doctorData[key_name]
                    );
                }
            } else if (education_fields.includes(key)) {
                if (
                    doctorData['education'] == null ||
                    Object.entries(doctorData['education']).length == 0
                ) {
                    doctorFormChecker[key] = true;
                } else if (
                    doctorData['education'] != null ||
                    Object.entries(doctorData['education']).length != 0
                ) {
                    doctorFormChecker[key] = this.arrayChecker1(
                        doctorData['education'][key.toString()]
                    );
                }
            } else if (key === 'profile_photo') {
                doctorFormChecker[key] = this.fileChecker2(photo_profile);
            }
            // else if (Object.keys(doctorFormChecker)[i] === 'signature') {
            //     if (signature_option === 'upload')
            //         doctorFormChecker[Object.keys(doctorFormChecker)[i]] =
            //             this.fileChecker2(signature);
            //     else if (signature_option === 'draw')
            //         doctorFormChecker[Object.keys(doctorFormChecker)[i]] = true;
            //     //since can't check
            //     else
            //         doctorFormChecker[Object.keys(doctorFormChecker)[i]] =
            //             false;
            // }
            else if (key === 'recaptcha') {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (key === 'role_id') {
                if (!is_super_admin) {
                    doctorFormChecker[key] = true;
                } else if (is_super_admin) {
                    doctorFormChecker[key] = this.stringChecker2(
                        doctorData[key.toString()]
                    );
                }
            } else if (key === 'featured_doctor_id') {
                if (!is_super_admin) {
                    doctorFormChecker[key] = true;
                } else if (is_super_admin) {
                    doctorFormChecker[key] = this.booleanChecker2(
                        doctorData[key.toString()]
                    );
                }
            } else if (key === 'agree') {
                doctorFormChecker[key] = agree;
            } else if (key === 'd_password') {
                doctorFormChecker[key] = agree;
            }
            if (key === 'user_source_id') {
                if (doctorData.user_source_id == 12) {
                    doctorFormChecker.other_source = this.stringChecker1(
                        doctorData.other_user_source
                    );
                }
            }
        }

        return doctorFormChecker;
    }

    async getDoctorRegFormErrors(
        doctor_form_boolean: boolean_dregistration,
        national_license: boolean
    ) {
        let labels_doctorreg: labels_doctorreg =
            this.labels_doctorRegistration_init();
        let error_messages: string[] = [];
        let is_errors: boolean = true;
        let result: PromiseResult;

        let password_fields: string[] = ['d_password_equal'];
        let number_string_fields_checker: string[] = [
            'pin_number_string',
            'primary_contact_number_number_string'
        ];
        if (national_license) {
            labels_doctorreg.states_to_practice = 'License No';
        } else if (!national_license) {
            labels_doctorreg.states_to_practice = 'States to Practice';
        }

        for (const key of Object.keys(doctor_form_boolean)) {
            if (!doctor_form_boolean[key]) {
                is_errors = false;
                if (password_fields.includes(key)) {
                    error_messages.push(
                        'Password and Confirm Password do not match.'
                    );
                } else if (number_string_fields_checker.includes(key)) {
                    error_messages.push(
                        labels_doctorreg[key] +
                        ' should have only only numbers.'
                    );
                } else {
                    error_messages.push(
                        labels_doctorreg[key] + ' is required.'
                    );
                }
            }
        }
        result = {
            success: is_errors,
            error: null,
            data: error_messages
        };
        return result;
    }

    async DoctorProfileUpdateFormSubmitChecker(
        doctorData: DoctorProfileUpdateDataSubmit,
        is_super_admin: boolean = false,
        is_photo_profile: boolean,
        photo_profile: any,
        is_resume_cv: boolean,
        resume_cv: any,
        is_signature: boolean,
        signature_option: string,
        signature: any,
        password: string,
        confirm_password: string
    ) {
        let doctorFormChecker: boolean_DoctorProfileUpdateDataSubmit =
            this.boolean_DoctorProfileUpdateDataSubmit_init();
        let string_fields_1 = [
            'first_name',
            'last_name',
            'gender',
            'city',
            'address_line_1',
            'primary_contact_number',
            'zip_code',
            'npi_number',
            'degree',
            'description'
        ];
        //^^^initialized with empty string^^^
        let string_fields_2 = ['date_of_birth', 'state_name', 'salutation'];
        // ^^^initialized with null^^^
        let number_fields_2 = [
            'country_id',
            'primary_speciality_id',
            'years_experience'
        ];
        // ^^^initialized with null^^^
        let array_fields_1 = [
            'language_id',
            'states_to_practice',
            'board_certification'
        ];
        //^^^initialized with empty array^^^
        let education_fields = ['medical_school', 'residency'];
        //^^^initialized with empty object^^^
        for (const key of Object.keys(doctorFormChecker)) {
            if (string_fields_1.includes(key)) {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (string_fields_2.includes(key)) {
                doctorFormChecker[key] = this.stringChecker2(
                    doctorData[key.toString()]
                );
            } else if (number_fields_2.includes(key)) {
                doctorFormChecker[key] = this.numberChecker2(
                    doctorData[key.toString()]
                );
            } else if (array_fields_1.includes(key)) {
                doctorFormChecker[key] = this.arrayChecker1(
                    doctorData[key.toString()]
                );
            } else if (education_fields.includes(key)) {
                if (
                    doctorData['education'] == null ||
                    Object.entries(doctorData['education']).length == 0
                ) {
                    doctorFormChecker[key] = true;
                } else if (
                    doctorData['education'] != null ||
                    Object.entries(doctorData['education']).length != 0
                ) {
                    doctorFormChecker[key] = this.arrayChecker1(
                        doctorData['education'][key.toString()]
                    );
                }
            } else if (key === 'd_password') {
                doctorFormChecker['is_password'] = true;

                if (doctorData['is_password']) {
                    doctorFormChecker[key] = this.stringChecker1(
                        doctorData[key.toString()]
                    );
                    if (confirm_password == password) {
                        doctorFormChecker['d_password_equal'] = true;
                    } else if (confirm_password != password) {
                        doctorFormChecker['d_password_equal'] = false;
                    }
                } else if (!doctorData['is_password']) {
                    doctorFormChecker[key] = true;
                    doctorFormChecker['d_password_equal'] = true;
                }
            } else if (key === 'profile_photo') {
                doctorFormChecker['is_profile_photo'] = true;
                if (is_photo_profile)
                    doctorFormChecker[key] = this.fileChecker2(photo_profile);
                else if (!is_photo_profile) doctorFormChecker[key] = true;
            } else if (key === 'resume_cv') {
                doctorFormChecker['is_resume_cv'] = true;
                if (is_resume_cv)
                    doctorFormChecker[key] = this.fileChecker2(resume_cv);
                else if (!is_resume_cv) doctorFormChecker[key] = true;
            } else if (key === 'pin') {
                doctorFormChecker['is_pin'] = true;
                if (doctorData['is_pin'])
                    doctorFormChecker[key] = this.stringChecker1(
                        doctorData[key.toString()]
                    );
                else if (!doctorData['is_pin']) doctorFormChecker[key] = true;
            } else if (key === 'signature') {
                doctorFormChecker['is_signature'] = true;
                if (is_signature) {
                    if (signature_option === 'upload')
                        doctorFormChecker[key] = this.fileChecker2(signature);
                    else if (signature_option === 'draw')
                        doctorFormChecker[key] = true;
                    //since can't check
                    else doctorFormChecker[key] = false;
                } else if (!is_signature) doctorFormChecker[key] = true;
            } else if (key === 'recaptcha') {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (key === 'role_id') {
                if (!is_super_admin) {
                    doctorFormChecker[key] = true;
                } else if (is_super_admin) {
                    doctorFormChecker[key] = this.stringChecker2(
                        doctorData[key.toString()]
                    );
                }
            } else if (key === 'featured_doctor_id') {
                if (!is_super_admin) {
                    doctorFormChecker[key] = true;
                } else if (is_super_admin) {
                    doctorFormChecker[key] = this.booleanChecker2(
                        doctorData[key.toString()]
                    );
                }
            }
        }
        return doctorFormChecker;
    }

    async getDoctorProfileUpdateFormErrors(
        doctor_form_boolean: boolean_DoctorProfileUpdateDataSubmit,
        national_license: boolean
    ) {
        let labels_doctorreg: labels_doctorreg =
            this.labels_doctorRegistration_init();
        let error_messages: string[] = [];
        let is_errors: boolean = true;
        let result: PromiseResult;

        let password_fields: string[] = ['d_password_equal'];
        if (national_license) {
            labels_doctorreg.states_to_practice = 'License No';
        } else if (!national_license) {
            labels_doctorreg.states_to_practice = 'States to Practice';
        }

        for (const key of Object.keys(doctor_form_boolean)) {
            if (!doctor_form_boolean[key]) {
                is_errors = false;
                if (password_fields.includes(key)) {
                    error_messages.push(
                        'Password and Confirm Password do not match.'
                    );
                } else {
                    error_messages.push(
                        labels_doctorreg[key] + ' is required.'
                    );
                }
            }
        }
        result = {
            success: is_errors,
            error: null,
            data: error_messages
        };
        return result;
    }

    async OtherMedicalFormSubmitChecker(
        doctorData: medprofregistration,
        is_super_admin: boolean = false,
        photo_profile: File,
        agree: boolean
    ) {
        let doctorFormChecker: boolean_medprofregistration =
            this.boolean_medprofregistration_init();
        let string_fields_1 = [
            'first_name',
            'last_name',
            'gender',
            'd_email',
            'city',
            'address_line_1',
            'primary_contact_number',
            'zip_code',
            'description',
            'd_password',
            'confirm_d_password',
            //'other_source'
        ];
        //^^^initialized with empty string^^^
        let string_fields_2 = [
            'date_of_birth',
            'state_name',
            'primary_occupation'
        ];
        // ^^^initialized with null^^^
        let number_fields_2 = [
            'country_id',
            'years_of_experience',
            'user_source_id'
        ];
        let password_fields = ['d_password_equal'];
        // ^^^initialized with null^^^
        let array_fields_1 = ['language_id'];
        //^^^initialized with empty array^^^
        let education_fields = ['school'];
        //^^^initialized with empty object^^^
        for (const key of Object.keys(doctorFormChecker)) {
            if (string_fields_1.includes(key)) {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (string_fields_2.includes(key)) {
                doctorFormChecker[key] = this.stringChecker2(
                    doctorData[key.toString()]
                );
            } else if (number_fields_2.includes(key)) {
                doctorFormChecker[key] = this.numberChecker2(
                    doctorData[key.toString()]
                );
            } else if (array_fields_1.includes(key)) {
                doctorFormChecker[key] = this.arrayChecker1(
                    doctorData[key.toString()]
                );
            } else if (password_fields.includes(key)) {
                doctorFormChecker[key] =
                    doctorFormChecker['d_password'] ==
                    doctorFormChecker['confirm_d_password'];
            } else if (education_fields.includes(key)) {
                // if (doctorData["education"] == null || Object.entries(doctorData["education"]).length == 0) {
                //   doctorFormChecker[key] = true;
                // }
                if (
                    doctorData['education'] != null ||
                    doctorData['education'].length != 0
                ) {
                    doctorFormChecker[key] = this.arrayChecker1(
                        doctorData['education']
                    );
                }
            } else if (key === 'profile_photo') {
                doctorFormChecker[key] = this.fileChecker2(photo_profile);
            } else if (key === 'recaptcha') {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (key === 'agree') {
                doctorFormChecker[key] = agree;
            }
            if (key === 'user_source_id') {
                if (doctorData.user_source_id == 12) {
                    doctorFormChecker.other_source = this.stringChecker1(
                        doctorData.other_source
                    );
                }
            }
        }

        return doctorFormChecker;
    }

    async getOtherMedicalRegFormErrors(
        doctor_form_boolean: boolean_medprofregistration
    ) {
        let labels_doctorreg: labels_doctorreg =
            this.labels_doctorRegistration_init();
        let error_messages: string[] = [];
        let is_errors: boolean = true;
        let result: PromiseResult;

        let password_fields: string[] = ['d_password_equal'];

        for (const key of Object.keys(doctor_form_boolean)) {
            if (!doctor_form_boolean[key]) {
                is_errors = false;
                if (password_fields.includes(key)) {
                    error_messages.push(
                        'Password and Confirm Password do not match.'
                    );
                } else {
                    error_messages.push(
                        labels_doctorreg[key] + ' is required.'
                    );
                }
            }
        }
        result = {
            success: is_errors,
            error: null,
            data: error_messages
        };
        return result;
    }

    async OtherMedicalUpdateFormSubmitChecker(
        doctorData: medprofUpdateDataSubmit,
        is_super_admin: boolean = false,
        is_photo_profile: boolean,
        photo_profile: any,
        is_resume_cv: boolean,
        resume_cv: any,
        password: string,
        confirm_password: string
    ) {
        let doctorFormChecker: boolean_medprofUpdateDataSubmit =
            this.boolean_medprofUpdateDataSubmit_init();
        let string_fields_1 = [
            'first_name',
            'last_name',
            'gender',
            // 'd_email',
            'city',
            'address_line_1',
            'primary_contact_number',
            'zip_code',
            'description'
        ];
        //^^^initialized with empty string^^^
        let string_fields_2 = [
            'date_of_birth',
            'state_name',
            'primary_occupation'
        ];
        // ^^^initialized with null^^^
        let number_fields_2 = ['country_id', 'years_of_experience'];
        // ^^^initialized with null^^^
        let array_fields_1 = ['language_id'];
        //^^^initialized with empty array^^^
        let education_fields = ['school'];
        //^^^initialized with empty object^^^
        for (const key of Object.keys(doctorFormChecker)) {
            if (string_fields_1.includes(key)) {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (string_fields_2.includes(key)) {
                doctorFormChecker[key] = this.stringChecker2(
                    doctorData[key.toString()]
                );
            } else if (number_fields_2.includes(key)) {
                doctorFormChecker[key] = this.numberChecker2(
                    doctorData[key.toString()]
                );
            } else if (array_fields_1.includes(key)) {
                doctorFormChecker[key] = this.arrayChecker1(
                    doctorData[key.toString()]
                );
            } else if (education_fields.includes(key)) {
                // if (doctorData["education"] == null || Object.entries(doctorData["education"]).length == 0) {
                //   doctorFormChecker[key] = true;
                // }
                if (
                    doctorData['education'] != null ||
                    doctorData['education'].length != 0
                ) {
                    doctorFormChecker[key] = this.arrayChecker1(
                        doctorData['education']
                    );
                }
            } else if (key === 'recaptcha') {
                doctorFormChecker[key] = this.stringChecker1(
                    doctorData[key.toString()]
                );
            } else if (key === 'd_password') {
                doctorFormChecker['is_password'] = true;

                if (doctorData['is_password']) {
                    doctorFormChecker[key] = this.stringChecker1(
                        doctorData[key.toString()]
                    );
                    if (confirm_password == password) {
                        doctorFormChecker['d_password_equal'] = true;
                    } else if (confirm_password != password) {
                        doctorFormChecker['d_password_equal'] = false;
                    }
                } else if (!doctorData['is_password']) {
                    doctorFormChecker[key] = true;
                    doctorFormChecker['d_password_equal'] = true;
                }
            } else if (key === 'profile_photo') {
                doctorFormChecker['is_profile_photo'] = true;
                if (is_photo_profile)
                    doctorFormChecker[key] = this.fileChecker2(photo_profile);
                else if (!is_photo_profile) doctorFormChecker[key] = true;
            } else if (key === 'resume_cv') {
                doctorFormChecker['is_resume_cv'] = true;
                if (is_resume_cv)
                    doctorFormChecker[key] = this.fileChecker2(resume_cv);
                else if (!is_resume_cv) doctorFormChecker[key] = true;
            }
        }

        return doctorFormChecker;
    }

    async getOtherMedicalUpdateFormErrors(
        doctor_form_boolean: boolean_medprofUpdateDataSubmit
    ) {
        let labels_doctorreg: labels_doctorreg =
            this.labels_doctorRegistration_init();
        let error_messages: string[] = [];
        let is_errors: boolean = true;
        let result: PromiseResult;

        let password_fields: string[] = ['d_password_equal'];
        for (const key of Object.keys(doctor_form_boolean)) {
            if (!doctor_form_boolean[key]) {
                is_errors = false;
                if (password_fields.includes(key)) {
                    error_messages.push(
                        'Password and Confirm Password do not match.'
                    );
                } else {
                    error_messages.push(
                        labels_doctorreg[key] + ' is required.'
                    );
                }
            }
        }
        result = {
            success: is_errors,
            error: null,
            data: error_messages
        };
        return result;
    }
}
